import React, { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Bell, CheckCheck } from 'lucide-react';

const Notifications = () => {
  const [items, setItems] = useState([]);
  const load = async () => { const { data } = await api.get('/notifications'); setItems(data); };
  useEffect(() => { load(); }, []);
  const markAll = async () => { await api.post('/notifications/read-all'); load(); };
  return (
    <div className="p-6 max-w-2xl mx-auto">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-3xl font-black tracking-tighter display flex items-center gap-2"><Bell className="h-7 w-7 text-[#1E3A8A]" />Notifications</h1>
        <Button variant="outline" onClick={markAll} className="gap-2" data-testid="mark-all-read"><CheckCheck className="h-4 w-4" />Mark all read</Button>
      </div>
      {items.length === 0 && <div className="text-sm text-[var(--bz-muted)] p-6 bz-card">No notifications yet.</div>}
      {items.map((n, i) => (
        <Card key={n.notification_id || n.at || i} className={`p-4 mb-2 ${n.read ? '' : 'border-l-4 border-l-[#1D4ED8]'}`}>
          <div className="font-bold">{n.title}</div>
          <div className="text-sm text-[var(--bz-muted)]">{n.body}</div>
          <div className="text-[10px] text-[var(--bz-muted)] mt-1">{new Date(n.at).toLocaleString()}</div>
        </Card>
      ))}
    </div>
  );
};

export default Notifications;
